export default __webpack_public_path__ + "static/media/Stalker's Mask of the Firebringer.74568198.jpg";